import { Menu }                       from "@mantine/core";
import { useViewportSize }            from "@mantine/hooks";
import { useColorScheme }             from "@mantine/hooks";
import Link                           from "next/link";
import React, { useEffect, useState } from "react";

import { useSetDarkMode, useSetDeviceTheme } from "_common/hooks/global";
import { useGetDarkMode, useGetDeviceTheme } from "_common/hooks/global";
import Icon                                  from "_components/atoms/icon";
import Typography                            from "_components/atoms/typography";
import AppearanceMenu                        from "_components/molecules/menu/appearanceMenu";
import useStyles                             from "_styles/pages/blogs/navbar.js";

const navbar = ( { categories, selectedCategory } ) => {
	const [ open, setOpen ]                 = useState ( false );
	const [ showDropDown, setShowDropDown ] = useState ( false );
	const darkMode                          = useGetDarkMode ();
	const isDeviceTheme                     = useGetDeviceTheme ();
	const { width }                         = useViewportSize ();
	let deviceViewTab                       = width && width <= 1250;
	const { classes }                       = useStyles ( { open, showDropDown, deviceViewTab } );
	const colorScheme                       = useColorScheme ();
	const toggleDarkMode                    = useSetDarkMode ();
	const toggleDeviceTheme                 = useSetDeviceTheme ();

	useEffect ( () => {
		if ( isDeviceTheme ) {
			toggleDarkMode ( colorScheme === "dark" );
		}
	}, [ colorScheme, isDeviceTheme ] );

	const handleClose = () => {
		setOpen ( false );
	};

	const onThemeChange = key => {
		if ( key === "device" ) {
			toggleDeviceTheme ( prev => !prev );

			return;
		}

		if ( key === "light" )
			toggleDarkMode ( false );

		if ( key === "dark" )
			toggleDarkMode ( true );

		toggleDeviceTheme ( false );
	};

	const toggleCategoriesMenu = () => {
		setShowDropDown ( !showDropDown );
	};

	const getCategoryMap = ( categories, selectedCategory ) => {

		return ( categories?.map ( cat => {

			if ( cat?.name === "Featured" ) return;

			const isSelectedCategory = cat?.name === selectedCategory;

			return (
				<Link
					key = { cat?.id }
					href = { `/blogs/category/${ cat?.slug }` }
				>
					<div
						className = { deviceViewTab ? classes.tab : `${ classes.tab2 } ${ isSelectedCategory ? "active" : "" } ` }
					>
						<Typography
							key = { cat?.id }
							className = { classes.categoryName }
							style = { { color: cat?.slug === selectedCategory ? "#126bd5" : "", fontWeight: deviceViewTab ? "700" : "" } }
							title = { cat?.name }
						/>
					</div>

				</Link>
			);
		} ) );
	};

	return (
		<div className = { classes.navbarContainer }>

			<Link
				href = { "/blogs" }
			>
				<div className = { classes.startSection }>

					<Icon
						className = { classes.rooterLogo }
						name = "rooterInfiniteLogo"
					/>

					<Typography
						className = { classes.blogText }
						title = { "Blogs" }
						weight = "900"
					/>
				</div>
			</Link>

			<div className = { classes.middleSection }>
				{deviceViewTab ? (
					<button className = { classes.categoriesButton }
						onClick = { toggleCategoriesMenu }
					>
						Category
						{" "}

						<Icon
							name = "arrowDown"
							size = "1.5rem"
						/>

						{showDropDown && (
							<div className = { classes.categoriesMenu }>
								{getCategoryMap ( categories, selectedCategory )}
							</div>
						)}

					</button>
				) : (
					getCategoryMap ( categories, selectedCategory )
				)}

			</div>

			<div className = { classes.endSection }>
				<Link passHref
					href = "https://web.rooter.gg/"
					rel = "noopener noreferrer"
					target = "_blank"
				>
					<div className = { classes.rooterButton }>
						<Typography
							className = { classes.linkColor }
							title = { "Visit Rooter.gg" }
						/>
					</div>
				</Link>

			</div>

			<Menu
				keepMounted
				classNames = { {
					dropdown  : classes.mainMenuContainer,
					itemLabel : classes.itemLabel,
					item      : classes.item
				} }
				position = "bottom-end"
				radius = { "lg" }
				styles = { { itemLabel: { display: "flex", justifyContent: "start" }, item: { borderRadius: "0" } } }
			>
				<Menu.Target>

					<div>

						<Icon
							className = { classes.dotsIcon }
							name = "menuDots"
						/>
					</div>
				</Menu.Target>

				<Menu.Dropdown>

					<AppearanceMenu
						hideBackBtn
						darkMode = { darkMode }
						isDeviceTheme = { isDeviceTheme }
						onClickBack = { handleClose }
						onThemeChange = { onThemeChange }
					/>
				</Menu.Dropdown>
			</Menu>

		</div>
	);
};

export default navbar;
